import { TFunction } from 'i18next'

import {
  ConnectivityState as ProductConnectivityState,
  OccupancyState as ProductOccupancyState,
  PeripheralsState as ProductPeripheralsState,
} from '../data/product'
import {} from '../data'

export const productConnectivityStates = [
  ProductConnectivityState.Connected,
  ProductConnectivityState.ConnectivityLost,
  ProductConnectivityState.Disconnected,
  ProductConnectivityState.NeverOnline,
]

export function titleForProductConnectivityState(state: ProductConnectivityState | undefined, t: TFunction) {
  switch (state) {
    case ProductConnectivityState.Connected:
      return t('Online')
    case ProductConnectivityState.ConnectivityLost:
      return t('Connection lost')
    case ProductConnectivityState.Disconnected:
      return t('Offline')
    case ProductConnectivityState.NeverOnline:
      return t('Never online')
    default:
      return t('Unknown')
  }
}

export const productPeripheralStates = [
  ProductPeripheralsState.Connected,
  ProductPeripheralsState.SensorDisconnected,
  ProductPeripheralsState.LedDisconnected,
  ProductPeripheralsState.SensorAndLedDisconnected,
  ProductPeripheralsState.Unknown,
]

export function titleForProductPeripheralState(state: ProductPeripheralsState | undefined, t: TFunction) {
  switch (state) {
    case ProductPeripheralsState.Connected:
      return t('Connected')
    case ProductPeripheralsState.SensorDisconnected:
      return t('Sensor disconnected')
    case ProductPeripheralsState.LedDisconnected:
      return t('Led disconnected')
    case ProductPeripheralsState.SensorAndLedDisconnected:
      return t('Sensor and led disconnected')
    case ProductPeripheralsState.Unknown:
    default:
      return t('Unknown')
  }
}

export const productOccupancyStates = [
  ProductOccupancyState.Unknown,
  ProductOccupancyState.Free,
  ProductOccupancyState.Occupied,
]

export function titleForProductOccupancyState(state: ProductOccupancyState | undefined, t: TFunction) {
  switch (state) {
    case ProductOccupancyState.Free:
      return t('Free')
    case ProductOccupancyState.Occupied:
      return t('Occupied')
    default:
      return t('Unknown')
  }
}
